import { Employee as EmployeeType } from 'types/models/Employee';
import Section from '@components/Section';
import Typography from '@components/atoms/Typography';
import Employee from '@components/Employee';
import { FormattedMessage } from 'utils/intl';

import messages from './ConferencesContacts.messages';
import classes from './ConferencesContacts.module.scss';

type Props = {
  employees: EmployeeType[];
};

const ConferencesContacts = ({ employees }: Props) => (
  <Section classes={{ root: classes.section }} title={<FormattedMessage {...messages.title} />}>
    <div className={classes.content}>
      <div className={classes.descriptionWrapper}>
        <Typography variant="h1" renderAs="div">
          <FormattedMessage {...messages.descriptionTitle} />
        </Typography>
        <Typography className={classes.description} variant="h4" renderAs="div">
          <FormattedMessage {...messages.description} />
        </Typography>
      </div>
      <div className={classes.employees}>
        {employees.map((employee) => (
          <Employee key={employee.id} employee={employee} />
        ))}
      </div>
    </div>
  </Section>
);

export default ConferencesContacts;
